export default "__VITE_ASSET__CQpOgwOR__"